import { Navigate, useLocation } from 'react-router-dom';
import { mapLegacyPathToCanonical } from '../config/canonicalPaths';
import { useAuth } from '../context/AuthContext';

/** In-app redirect from legacy paths to canonical surface paths (RSW-330). */
export default function LegacyPathRedirect() {
  const { pathname, search, hash } = useLocation();
  const { userType } = useAuth();
  const canonical = mapLegacyPathToCanonical(pathname, { userType });

  if (!canonical) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={`${canonical}${search}${hash}`} replace />;
}
